
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import * as React from 'react';
import LegalLayout from '@/components/layout/LegalLayout';
import useTranslation from 'next-translate/useTranslation';
import Trans from 'next-translate/Trans';
import Seo from '@/components/Seo';

export default function TermsAndConditionsPage() {
  const { t } = useTranslation('terms');
  return (
    <LegalLayout>
      <Seo title={t('seo:FOOTER_TERMS_AND_CONDITIONS_OF_SALE')} />
      <h1 className='subtitle-legal lg:pt-12' id='terms-of-purchase'>
        {t('terms:p_title')}
      </h1>
      <p className='pb-4'>{t('terms:update_date')}</p>
      <hr className='border-brand-500 py-4' />
      <ol className='ml-8 list-decimal space-y-4 marker:font-secondary marker:text-3xl marker:font-extralight marker:text-brand-500'>
        <div className='space-y-4'>
          <li>
            <h2>{t('terms:p_title_1')}</h2>
          </li>
          <p>
            <Trans
              i18nKey='terms:p_subtitle_1_1'
              components={{
                b: <strong />,
              }}
            />
          </p>
          <p>{t('terms:p_subtitle_1_2')}</p>
          <p>{t('terms:p_subtitle_1_3')}</p>

          <li>
            <h2>{t('terms:p_title_2')}</h2>
          </li>
          <p>
            <Trans
              i18nKey='terms:p_subtitle_2_1'
              components={{
                b: <strong />,
              }}
            />
          </p>
          <p>{t('terms:p_subtitle_2_2')}</p>

          <li>
            <h2>{t('terms:p_title_3')}</h2>
          </li>
          <p>{t('terms:p_subtitle_3_1')}</p>
          <p>{t('terms:p_subtitle_3_2')}</p>

          <li>
            <h2>{t('terms:p_title_4')}</h2>
          </li>
          <p>{t('terms:p_subtitle_4_1')}</p>
          <p>{t('terms:p_subtitle_4_2')}</p>
          <p>{t('terms:p_subtitle_4_3')}</p>
          <p>{t('terms:p_subtitle_4_4')}</p>
          <p>{t('terms:p_subtitle_4_5')}</p>
          <p>{t('terms:p_subtitle_4_6')}</p>
          <p>{t('terms:p_subtitle_4_7')}</p>
          <p>{t('terms:p_subtitle_4_8')}</p>

          <li>
            <h2>{t('terms:p_title_5')}</h2>
          </li>
          <p>{t('terms:p_subtitle_5_1')}</p>
          <p>{t('terms:p_subtitle_5_2')}</p>
          <p>{t('terms:p_subtitle_5_3')}</p>
          <p>{t('terms:p_subtitle_5_5')}</p>
          <p>{t('terms:p_subtitle_5_6')}</p>
          <p>{t('terms:p_subtitle_5_7')}</p>
          <p>{t('terms:p_subtitle_5_8')}</p>

          <li>
            <h2>{t('terms:p_title_6')}</h2>
          </li>
          <p>{t('terms:p_subtitle_6_1')}</p>
          <p>{t('terms:p_subtitle_6_2')}</p>
          <p>{t('terms:p_subtitle_6_3')}</p>
          <p>{t('terms:p_subtitle_6_4')}</p>
          <p>{t('terms:p_subtitle_6_5')}</p>
          <p>{t('terms:p_subtitle_6_7')}</p>
          <p>{t('terms:p_subtitle_6_8')}</p>
        </div>
        <div className='space-y-4'>
          <li>
            <h2>{t('terms:p_title_7')}</h2>
          </li>
          <p>{t('terms:p_subtitle_7_1')}</p>
          <p>{t('terms:p_subtitle_7_2')}</p>
          <p>{t('terms:p_subtitle_7_3')}</p>
          <p>{t('terms:p_subtitle_7_4')}</p>
          <p>{t('terms:p_subtitle_7_5')}</p>
          <p>{t('terms:p_subtitle_7_6')}</p>

          <li>
            <h2>{t('terms:p_title_8')}</h2>
          </li>
          <p>{t('terms:p_subtitle_8_1')}</p>
          <p>{t('terms:p_subtitle_8_2')}</p>
          <li>
            <h2>{t('terms:p_title_9')}</h2>
          </li>
          <p>{t('terms:p_subtitle_9_1')}</p>
          <p>{t('terms:p_subtitle_9_2')}</p>
          <p>{t('terms:p_subtitle_9_3')}</p>
          <p>{t('terms:p_subtitle_9_4')}</p>
          <p>{t('terms:p_subtitle_9_5')}</p>
          <li>
            <h2>{t('terms:p_title_10')}</h2>
          </li>
          <p>{t('terms:p_subtitle_10_1')}</p>
          <p>{t('terms:p_subtitle_10_2')}</p>
          <p>{t('terms:p_subtitle_10_3')}</p>
          <p>{t('terms:p_subtitle_10_4')}</p>

          <li>
            <h2>{t('terms:p_title_11')}</h2>
          </li>
          <p>{t('terms:p_subtitle_11_1')}</p>
          <p>{t('terms:p_subtitle_11_2')}</p>
          <p>{t('terms:p_subtitle_11_3')}</p>

          <li>
            <h2>{t('terms:p_title_12')}</h2>
          </li>
          <p>{t('terms:p_subtitle_12_1')}</p>

          <li>
            <h2>{t('terms:p_title_13')}</h2>
          </li>
          <p>{t('terms:p_subtitle_13_1')}</p>
          <p>{t('terms:p_subtitle_13_2')}</p>
          <p>{t('terms:p_subtitle_13_3')}</p>

          <li>
            <h2>{t('terms:p_title_14')}</h2>
          </li>
          <p>{t('terms:p_subtitle_14_1')}</p>
          <p>{t('terms:p_subtitle_14_2')}</p>

          <li>
            <h2>{t('terms:p_title_15')}</h2>
          </li>
          <p>{t('terms:p_subtitle_15_1')}</p>
          <p>{t('terms:p_subtitle_15_2')}</p>
          <p>{t('terms:p_subtitle_15_3')}</p>
        </div>
      </ol>
    </LegalLayout>
  );
}


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/general-terms-and-conditions-of-purchase/index',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  